import React from "react";
import Modal from "@mui/material/Modal";
import TextView from "../../../components/TextView";
import Button from "../../../components/Button";
import { colors } from "../../../utils";
import styled from "styled-components";
import icon from "assets/images/bank-icon.svg"

const Container = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 400px;
  width: 50vw;
  min-width: 550px;
  background-color: ${colors.white};
  border-radius: 10px;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ButtonView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
`;

const Content = styled.div`
    width: 70%;
    margin: auto;
    margin-top:30px;
`

const ListItem = styled.li`

`

export default function PaymentDetailsPopup({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Container>
        <Icon src={icon} />
        <TextView
          variant="title"
          style={{ textAlign: "center", marginBottom: 10 }}
        >
          Payment Details
        </TextView>
        <TextView variant="subtitle" style={{ textAlign: "center" }}>
          Here are your bank details below:
        </TextView>
        <Content>
            <ul>
                <ListItem>Bank Name:</ListItem>
                <ListItem>Account Holder's name:</ListItem>
                <ListItem>Account Number:</ListItem>
                <ListItem>Account Type:</ListItem>
                </ul>
        </Content>
        <ButtonView>
          <Button
            variant={"secondary"}
            onClick={onClose}
            style={{
              width: 120,
              marginRight: 20,
            }}
          >
            Close
          </Button>

        </ButtonView>
      </Container>
    </Modal>
  );
}
